import { useQuery } from '@tanstack/react-query'
import { useAuth } from 'src/contexts/auth'
import { FarmController } from 'src/controllers/farm.controller'
import { FarmDto } from 'src/dto/farm.dto'

const farmController = new FarmController()

export function useGetAllFarms() {
  const { userFarm: farmId } = useAuth()

  return useQuery<FarmDto[], Error>({
    queryKey: ['getAllFarms'],
    queryFn: () => farmController.getAllFarms(),
    enabled: !!farmId
  })
}
